<sc-flex vertical fitHeight stretchContent class="truck-gc-case-dialog">

  <sc-title>
    <sc-dictionary-label dictionaryKey="tmc.visit.overview.gc-case-dialog.title"></sc-dictionary-label>
  </sc-title>



  <sc-flex-fitting-content vertical>

    <sc-padding>

      <app-truck-info-panel [carrier]="truck.carrier" [driver]="truck.driver" [identifier]="truck.numberPlate">
      </app-truck-info-panel>

      <sc-content-spacer></sc-content-spacer>

      <sc-flex fitHeight [centered]="true" vertical>
        <div class="qr-code-box">
          @if (truck.messagingReference) {
            <qrcode [qrdata]="truck.messagingReference" [scale]="8"></qrcode>
          }
        </div>
      </sc-flex>

    </sc-padding>
  </sc-flex-fitting-content>



  <sc-actionbar>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-close-button mat-dialog-close (click)="closeDialog()" dictionaryKey="shared.selection-dialog.action.close"></sc-close-button>
  </sc-actionbar>

</sc-flex>
